import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { Dictionary } from '../../../../shared/models/dictionary';
import { EntityTypes } from '../../../entity/entity-types';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';
import { Entities } from '../../../entity/entities';
import { EntityState } from '../../../entity/entity.reducer';
import { getDictionaryUnitStateListState } from '../unit-state.reducer';

const createState = (id: IdType) => createSelector(
  getDictionaryUnitStateListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createDictionaryUnitStateListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.unitState
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.unitState]], entities) as Dictionary[]
);

export const createDictionaryUnitStateListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createDictionaryUnitStateListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createDictionaryUnitStateListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createDictionaryUnitStateListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createDictionaryUnitStateListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
